import script from "./DataDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataDetail.vue?vue&type=script&setup=true&lang=ts"

import "./DataDetail.vue?vue&type=style&index=0&id=1b444851&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b444851"]])

export default __exports__